import { render, staticRenderFns } from "./LicenseSelector.vue?vue&type=template&id=31815e9b&scoped=true"
import script from "./LicenseSelector.vue?vue&type=script&lang=js"
export * from "./LicenseSelector.vue?vue&type=script&lang=js"
import "./LicenseSelector.vue?vue&type=style&index=0&id=31815e9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31815e9b",
  null
  
)

export default component.exports